module.exports = __webpack_public_path__ + "static/img/rank_background2.2db7c463.png";